module.exports = {
    recharge: {
        rechargeTitle: 'Пополнение трафика',
        loading: 'Загрузка...',
        did: 'DID',
        symbol: '$',
        total: 'Итого',
        expire: 'Истекает',
        unpaid: 'Не оплачено',
        historicalOrders: 'История заказов',
        noOrders: 'Нет заказов',
        orderNo: '№ заказа',
        buyTime: 'Время заказа',
        endTime: 'Истекает',
        disbursements: 'К оплате',
        cancelOrder: 'Отменить',
        pay: 'Оплатить',
        haveDoubts: 'Вопрос по заказу?',
        renew: 'Продлить сейчас',
        cardNumTips: 'Номер карты: см. рисунок',
        cardNumOrIccid: 'Введите номер 4G-карты или ICCID',
        query: 'Запрос',
        tips: 'Внимание',
        tips4G1: '1.Введите первые 19 цифр ICCID (рекомендуется сканирование).',
        tips4G11: '1.Введите первые 20 цифр ICCID (рекомендуется сканирование).',
        tips4G2: '2.Оплата трафика только на данной платформе. Другие способы недействительны.',
        tips4G3: '3.SIM-карта запрещена для использования в телефонах и мобильных устройствах — при обнаружении немедленная блокировка.',
        msgTips: 'Введите корректный ICCID',

    }
}

